import { HTMLAttributes } from 'react'

export const FILTER_ITEM_CLASS_NAME =
  'flex w-full cursor-pointer select-none items-center gap-x-2 rounded-lg p-2 text-sm outline-none transition-colors duration-300 hover:bg-blue-100 focus:bg-blue-100 focus:outline-none'

export type CompositeHTMLProps = Omit<HTMLAttributes<HTMLElement>, 'ref'> & {
  'data-active'?: string
  // floating-ui passes a callback ref — typed loosely to avoid
  // HTMLElement vs HTMLButtonElement conflicts when spreading onto buttons
  ref?: ((node: HTMLElement | null) => void) | null
}
